import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from 'react';

interface Props {
  onChange?: any;
  value?: string;
  inputClassName?: string;
  placeholder?: string;
  dataTestID?: string;
  isTall?: boolean;
}

const SearchInput: React.FC<Props> = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const marginVal = props.isTall ? '10' : '8';

  return (
    <div className="w-full">
      <input
        type="search"
        className={`outline-none p-2 pl-12 font-medium text-gray-800 rounded bg-white ${props.inputClassName}`}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={props.value}
        onBlur={() => setIsFocused(false)}
        onFocus={() => setIsFocused(true)}
        data-testid={props.dataTestID}
      />
      <div className={`pl-3 h-0 -mt-${marginVal} mb-${marginVal}`}>
        <SearchIcon className={`${isFocused ? 'text-blue-200' : 'text-gray-600'}`} />
      </div>
    </div>
  );
};

export default SearchInput;
